'use strict'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import { VueAuthenticate } from 'vue-authenticate'
import axios from 'axios'

import structs from '../structures'

Vue.use(VueAxios, axios)

const port = process.env.PORT
const host = '127.0.0.1'

const vueAuth = new VueAuthenticate(Vue.prototype.$http, {
  baseUrl: "",
  providers: {
    "google": {
      "scopePrefix":"",
      "clientId":"250938498010-7pjf6vfvfb8ijttthdiga15j2nccf75p.apps.googleusercontent.com"
    }
  }
})

vueAuth.options.providers.google.scope.push('https://www.googleapis.com/auth/spreadsheets')
vueAuth.options.providers.google.scope.push('https://www.googleapis.com/auth/drive')

//

const backendModule = {
  state:{
    isAuthenticated: vueAuth.isAuthenticated(),
    saved_settings: [],
  },
  getters:{
    logged_in: (state)=> {
      return state.isAuthenticated
    }
  },
  actions:{
    load_info: (context)=>{
      axios.get('/data/load_info', {params:{id_token:vueAuth.storage.getItem("id_token")}})
        .then(response=>{
          context.state.saved_settings=response.data
        })
    },
    load: (context, payload)=>{
      var rootState = context.rootState
      var params = payload
      params['id_token']=vueAuth.storage.getItem("id_token")
      axios.get('/data/load',{params})
      .then(response=>{
        var tmp = response.data
        var nodes = {}
        var links = {}
        //we need to change from serialized json with ids to classes and references
        Object.values(tmp.base_nodes).forEach(bn=>{
          nodes[bn.index] = new structs.Node()
          nodes[bn.index].copyObject(bn)
          nodes[bn.index].index=bn.index
        })

        Object.values(tmp.links).forEach( l =>{
          links[l.index] = new structs.Link(l.index,nodes[l.source_id],nodes[l.target_id],l.value,l.ref,l.is_loss)
        })

        Object.values(nodes).forEach(n=>{
          n.source_links = n.source_link_ids.map(l=>{return links[l]})
          n.target_links = n.target_link_ids.map(l=>{return links[l]})
          delete n.source_link_ids
          delete n.target_link_ids
        })

        var cnodes ={}
        Object.keys(tmp.compound_nodes).forEach(k=>{
          cnodes[k] = new structs.CompoundNode([])

          var kids = []
          var base = tmp.compound_nodes[k]
          base.child_ids.forEach( i=>{
            kids.push(nodes[i])
            nodes[i].parent = cnodes[k]
          })
          cnodes[k].children = kids

          cnodes[k].index=base.index
          cnodes[k].y_position=parseFloat(base.y_position)

          cnodes[k].group_id=base.group_id
        })


        if (tmp.cur_node_id>=0){
          tmp.cur_node = cnodes[tmp.cur_node_id]
          delete tmp.cur_node_id
        }

        if (tmp.up_down_id>=0){
          tmp.up_down = cnodes[tmp.up_down_id]
          delete tmp.up_down_id
        }

        /*
        var cc = {}
        Object.keys(tmp.columns).forEach(ck=>{
          var c = {}
          Object.keys(tmp.columns[ck]).forEach(gk=>{
            var g = {}
            Object.keys(tmp.columns[ck][gk]).forEach(nk=>{
              g[nk] = cnodes[tmp.columns[ck][gk][nk]]
              //cnodes[nk].group = g
            })
            c[gk]=g
          })
          cc[ck]=c
        })
        */

        tmp.nodes = cnodes
        tmp.links = links
        //tmp.columns = cc
        Object.keys(tmp).forEach(k=>{rootState[k]=tmp[k]})
      }).catch( error=> {
        console.log("oops! ", error)
      })
    },
    save: (context, payload)=>{
      var c_nodes = {}
      //assumes compound nodes don't share children
      var base_nodes = {}
      var rootState = context.rootState
      Object.keys(rootState.nodes).forEach(k=>{
        var cn = rootState.nodes[k]
        var ncn = Object.assign({},cn)
        ncn.y_position=ncn.y_position.toFixed(1)
        c_nodes[cn.index] = ncn
        cn.children.forEach(n=>{
          var nn = Object.assign({},n)
          delete nn.source_links
          delete nn.target_links
          delete nn.parent
          delete nn.origin
          base_nodes[n.index]=nn

          nn.source_link_ids = n.source_links.map(l=>{return l.index})
          nn.target_link_ids = n.target_links.map(l=>{return l.index})
        })
        ncn.child_ids = cn.children.map(n=>{return n.index})
        delete ncn.children
        //delete ncn.group
      })

      var out_links= {}
      Object.values(rootState.links).forEach(l=>{
        var ll = Object.assign({},l)
        delete ll.source
        delete ll.target
        out_links[l.index] = ll
        ll.source_id = l.source.index
        ll.target_id = l.target.index
      })

      /*
      var cc = {}
      var cols = context.state.columns
      Object.keys(cols).forEach( ck=>{
        var nc = {}
        Object.keys(cols[ck]).forEach( gk=>{
          var ng = {}
          Object.keys(cols[ck][gk]).forEach( nk=>{
            ng[nk] = cols[ck][gk][nk].index
          })
          nc[gk]=ng
        })
        cc[ck]=nc
      })
      */

      var packet = Object.assign({},rootState)
      packet.cur_node_id = rootState.cur_node ? rootState.cur_node.index : -1;
      packet.up_down_id = rootState.up_down ? rootState.up_down.index : -1;

      delete packet.cur_node
      delete packet.up_down
      delete packet.nodes
      delete packet.dirty
      delete packet.backend
      delete packet.node_by_name
      //TODO: might need to delete caches -- passthrough, crossover, etc
      delete packet.crossover_cache
      delete packet.passthrough_cache

      packet['base_nodes']=base_nodes
      packet['compound_nodes']=c_nodes
      packet['links']=out_links
      axios({method:'post',
             url:'/data/save',
             data:{title:payload.title,
                   notes:payload.notes,
                   id_token:vueAuth.storage.getItem("id_token"),
                   data:packet
                  }
            })
      .then(response=>{
        console.log(response)
        rootState.dirty=false
      }).catch( error=> {
        console.log("oops! ", error)
      })
    },
    login(context,payload){
      vueAuth.authenticate('google').then((response) => {
        context.commit('isAuthenticated', { isAuthenticated: vueAuth.isAuthenticated() })
        console.log("successful authentication. setting id token.")
        vueAuth.storage.setItem("id_token",response.data['id_token'])
        context.dispatch("load_info")
      }).catch ( error=>{
        console.log("authentication failed! ", error)
        context.dispatch('logout')
      })
    },
    logout(context,payload){
      vueAuth.logout()
      vueAuth.storage.removeItem("id_token")
      context.commit('isAuthenticated', { isAuthenticated: vueAuth.isAuthenticated() })
    },
  },
  mutations:{
    isAuthenticated (state, payload) {
      state.isAuthenticated = payload.isAuthenticated
    }
  }
}


export default backendModule



//////////////////
// WEBPACK FOOTER
// ./src/store/backend.js
// module id = null
// module chunks = 